var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconUserFemaleTeacherMath({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.25.75h-12m1.5 15.75h10.5m-11-9.75 1.5 1.5 2.5-4.5H20m-2.75 6.75h5.25m-2.625 2.25a.375.375 0 0 1 .375.375m-.75 0a.375.375 0 0 1 .375-.375m0 .75a.375.375 0 0 1-.375-.375m.75 0a.375.375 0 0 1-.375.375m0-6a.375.375 0 0 1 .375.375m-.75 0a.375.375 0 0 1 .375-.375m0 .75a.375.375 0 0 1-.375-.375m.75 0a.375.375 0 0 1-.375.375"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.25,
    cy: 3.75,
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.034 9.216 5.25 12.75 2.466 9.216A4.489 4.489 0 0 0 .75 12.75v3h2l.75 7.5H7l.75-7.5h2v-3a4.489 4.489 0 0 0-1.716-3.534ZM2.25 3.75s0 3-1.5 3m7.5-3s0 3 1.5 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconUserFemaleTeacherMath);
export default __webpack_public_path__ + "static/media/streamline-icon-user-female-teacher-math.b31aa656.svg";
export { ForwardRef as ReactComponent };